var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18673 6.68465V4.83701C7.18673 4.10166 7.78839 3.5 8.52374 3.5H15.4763C16.2117 3.5 16.8133 4.10166 16.8133 4.83701V6.68465M21.1701 12.6598V19.7448C21.1701 20.4293 20.6098 20.9896 19.9253 20.9896H4.07469C3.39017 20.9896 2.82988 20.4295 2.82988 19.7448V12.7012",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3402 14.7552C5.95066 14.5042 2 13.249 2 10.9895V8.04358C2 7.35798 2.55917 6.79877 3.24481 6.79877H20.7552C21.4408 6.79877 22 7.35802 22 8.04358V10.9895C22 13.2631 17.9994 14.5199 13.5768 14.7598",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4647 13.5208H13.5353V14.9523C13.5353 15.7396 12.8911 16.3838 12.1037 16.3838H11.8963C11.1089 16.3838 10.4647 15.7396 10.4647 14.9523V13.5208Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.10035ab1f8df0c8df58039b52d38946e.svg";
export { ForwardRef as ReactComponent };